import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "./changepassword.scss";
import { IconButton, InputAdornment, TextField } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

function ChangePassword() {
    const navigate = useNavigate()
    const [userObj, setUserObj] = useState({ oldPassword: "", newPassword: "", confirmPassword: "" });
    const [showPassword, setShowPassword] = useState(false)
    const [showPassword1, setShowPassword1] = useState(false)
    const [showPassword2, setShowPassword2] = useState(false)

    // const submit = async () => {
    //     let formData = { ...userObj };
    //     let pwd = new RegExp("^[a-zA-Z0-9-_.@#$]+$");
    //     if (!formData.oldPassword) {
    //         Swal.fire({
    //             text: 'Please enter old password.',
    //             showConfirmButton: false,
    //             icon: 'warning',
    //             timer: 3000,
    //         })
    //         return;
    //     } else if (!pwd.test(formData.oldPassword)) {
    //         Swal.fire({
    //             html: `Please enter valid old password. <br /> Only alphabets, numbers and some special characters such as @ $ # & - _ .`,
    //             icon: 'warning',
    //             confirmButtonColor: '#000',
    //             heightAuto: false,
    //         });
    //     } else if (!userObj.newPassword) {
    //       Swal.fire({
    //         text: "Please enter new password.",
    //         showConfirmButton: false,
    //         icon: "warning",
    //         timer: 3000,
    //       });
    //       return;
    //     } else if (!pwd.test(formData.newPassword)) {
    //       Swal.fire({
    //         html: `Please enter valid new password. <br /> Only alphabets, numbers and some special characters such as <strong>@ $ # & - _ .</strong> are allowed`,
    //         icon: "warning",
    //         confirmButtonColor: "#000",
    //         heightAuto: false,
    //       });
    //     } else if (userObj.oldPassword === userObj.newPassword) {
    //       Swal.fire({
    //         text: "New password should not match with old password!",
    //         showConfirmButton: false,
    //         icon: "warning",
    //         timer: 3000,
    //       });
    //       return;
    //     } else if (!userObj.confirmPassword) {
    //       Swal.fire({
    //         text: "Please enter confirm password.",
    //         showConfirmButton: false,
    //         icon: "warning",
    //         timer: 3000,
    //       });
    //       return;
    //     } else if (!pwd.test(formData.confirmPassword)) {
    //       Swal.fire({
    //         html: `Please enter valid confirm password. <br /> Only alphabets, numbers and some special characters such as @ $ # & - _ .`,
    //         icon: "warning",
    //         confirmButtonColor: "#000",
    //         heightAuto: false,
    //       });
    //     } else if (userObj.confirmPassword !== userObj.newPassword) {
    //       Swal.fire({
    //         text: "New password should match with confirm password!",
    //         showConfirmButton: false,
    //         icon: "warning",
    //         timer: 3000,
    //       });
    //       return;
    //     } else {
    //       const correl_id = localStorage.getItem("correl_id");
    //       let resData = await changePassword({ ...formData, correl_id });
    //       if (resData.status === "S") {
    //         Swal.fire({
    //           text: "Password changed, Redirecting to Login!",
    //           showConfirmButton: false,
    //           icon: "success",
    //           timer: 3000,
    //         }).then(() => {
    //           navigate("/app/login");
    //         });
    //       } else if (resData.status === "E" && resData.result_code === 404) {
    //         Swal.fire({
    //           text: "Account not found.",
    //           showConfirmButton: false,
    //           icon: "warning",
    //           timer: 3000,
    //         }).then(() => {
    //             localStorage.clear();
    //             navigate('/app/login')
    //         });
    //         return;
    //       } else if (resData.status === "E" && resData.result_code === 401) {
    //         Swal.fire({
    //           text: "Invalid old password.",
    //           showConfirmButton: false,
    //           icon: "warning",
    //           timer: 3000,
    //         });
    //         return;
    //       } else if (resData.status === "E" && resData.result_code === 400) {
    //         Swal.fire({
    //           text: "New password and confirm password does not match.",
    //           showConfirmButton: false,
    //           icon: "warning",
    //           timer: 3000,
    //         });
    //         return;
    //       } else if (
    //         resData.status === "F" &&
    //         resData.message === "Unauthorized - Missing token"
    //       ) {
    //         Swal.fire({
    //           text: "Please login with your credentials",
    //           icon: "warning",
    //           showConfirmButton: false,
    //           timer: 3000,
    //         }).then(() => {
    //           localStorage.clear();
    //           navigate("/app/login");
    //         });
    //       } else if (
    //         resData.status === "F" &&
    //         resData.message === "Unauthorized - Invalid token"
    //       ) {
    //         Swal.fire({
    //           text: "Please login with your credentials",
    //           icon: "warning",
    //           showConfirmButton: false,
    //           timer: 3000,
    //         }).then(() => {
    //           localStorage.clear();
    //           navigate("/app/login");
    //         });
    //       } else {
    //         Swal.fire({
    //           text: JSON.stringify(resData),
    //           showConfirmButton: false,
    //           icon: "warning",
    //           timer: 3000,
    //         });
    //         return;
    //       }
    //     }
    // }
    // const handleGoBack = () => {
    //     navigate(-1); // Equivalent to history.goBack()
    // };
    
    return (
        <>
            <div className='loginContainer pwd-screen'>
                <div className="row g-0 h-100 w-100">
                    <div className="col-6 d-none d-lg-block">
                        <div className="loginLeft d-none d-lg-flex">
                            <h5 className="headingText">
                                <strong>Welcome to UpwardIQ!</strong>
                            </h5>
                            <img
                                src={require("../../assets/image.png")}
                                alt="RECUPE"
                                className="vec-image"
                            />
                            <p>
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat eius sint officia laboriosam perferendis omnis nulla incidunt animi nobis tempora!
                            </p>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 h-100">
                        <div className="loginRight h-100">
                            <h5 className='loginText text-white'>Change Password</h5>
                            <TextField
                                id="outlined-basic"
                                label="Old Password"
                                variant="outlined"
                                type={showPassword ? 'text' : 'password'}
                                className='mb-4 cust-white-input-field w-100'
                                autoComplete='off'
                                value={userObj.oldPassword}
                                onChange={(ev) => {
                                    const input = ev.target.value;
                                    const allowedPattern = /^[a-zA-Z0-9.@_\-\s]*$/;
                                    // Allow input only if it matches the allowed pattern
                                    if (allowedPattern.test(input)) {
                                        setUserObj({
                                        ...userObj,
                                        oldPassword: input,
                                        });
                                    }
                                }}
                                inputProps={{
                                    minLength: 8,
                                    maxLength: 16,
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">
                                        <IconButton className='text-white'
                                            aria-label="toggle password visibility"
                                            onClick={() => { setShowPassword(!showPassword) }}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>,
                                }}
                            />
                            <TextField
                                id="outlined-basic"
                                label="New Password"
                                variant="outlined"
                                type={showPassword1 ? 'text' : 'password'}
                                className='mb-4 cust-white-input-field w-100'
                                autoComplete='off'
                                value={userObj.newPassword}
                                onChange={(ev) => {
                                    const input = ev.target.value;
                                    const allowedPattern = /^[a-zA-Z0-9.@_\-]*$/;
                                    // Allow input only if it matches the allowed pattern
                                    if (allowedPattern.test(input)) {
                                        setUserObj({
                                        ...userObj,
                                        newPassword: input,
                                        });
                                    }
                                }}
                                inputProps={{
                                    minLength: 8,
                                    maxLength: 16,
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">
                                        <IconButton className='text-white'
                                            aria-label="toggle password visibility"
                                            onClick={() => { setShowPassword1(!showPassword1) }}
                                            edge="end"
                                        >
                                            {showPassword1 ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>,
                                }}
                            />
                            <TextField
                                id="outlined-basic"
                                label="Confirm Password"
                                variant="outlined"
                                type={showPassword2 ? 'text' : 'password'}
                                className='mb-4 cust-white-input-field w-100'
                                autoComplete='off'
                                value={userObj.confirmPassword}
                                onChange={(ev) => {
                                    const input = ev.target.value;
                                    const allowedPattern = /^[a-zA-Z0-9.@_\-]*$/;
                                    // Allow input only if it matches the allowed pattern
                                    if (allowedPattern.test(input)) {
                                        setUserObj({
                                        ...userObj,
                                        confirmPassword: input,
                                        });
                                    }
                                }}
                                inputProps={{
                                    minLength: 8,
                                    maxLength: 16,
                                }}
                                onKeyDown={(ev) => {
                                    if (ev.key === "Enter") {
                                        ev.preventDefault();
                                        // submit();
                                    }
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">
                                        <IconButton className='text-white'
                                            aria-label="toggle password visibility"
                                            onClick={() => { setShowPassword2(!showPassword2) }}
                                            edge="end"
                                        >
                                            {showPassword2 ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>,
                                }}
                            />
                            <div>
                                <button className='btn btn-white rounded-pill text-uppercase'
                                    
                                >Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ChangePassword
